import React, { useEffect, useState } from 'react';
import { db } from '../../firebase/config';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';

export default function NotificationDiscussion() {
  const [messages, setMessages] = useState([]);
  const [selectedDossierId, setSelectedDossierId] = useState(null);

  const fetchMessagesForDossier = async (dossierId) => {
    if (!dossierId) return;
    try {
      const q = query(
        collection(db, 'messages'), // Correction ici : on cible la collection "messages" et non "notifications"
        where('dossierId', '==', dossierId),
        orderBy('timestamp', 'asc')
      );
      const snapshot = await getDocs(q);
      const fetchedMessages = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setMessages(fetchedMessages);
    } catch (error) {
      console.error('Erreur lors de la récupération des messages :', error);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      const { dossierId } = e.detail;
      setSelectedDossierId(dossierId);
      fetchMessagesForDossier(dossierId);
    };
    window.addEventListener('openDiscussion', handler);
    return () => window.removeEventListener('openDiscussion', handler);
  }, []);

  if (!selectedDossierId) return null;

  return (
    <div className="p-4 border-t border-gray-300 bg-white">
      <h3 className="text-xl font-bold text-indigo-700 mb-4">
        💬 Discussion pour le dossier : <span className="text-gray-800">{selectedDossierId}</span>
      </h3>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {messages.map((msg) => (
          <div key={msg.id} className="bg-indigo-50 rounded p-3 text-sm shadow">
            <div className="text-gray-900 font-semibold">📩 {msg.message}</div>
            <div className="text-gray-500 text-xs">⏱ {msg.timestamp?.toDate().toLocaleString() || '—'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
